"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionButtonContainer = exports.CloseButton = exports.IconColumn = exports.NotificationCard = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _utils = require("../../../utils");

var _skyPlane = _interopRequireDefault(require("../../../utils/skyPlane"));

var _Grid = _interopRequireDefault(require("../../Grid"));

var _Button = _interopRequireDefault(require("../../Button"));

var _constants = require("../constants");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationCard = (0, _styledComponents.default)(_Grid.default.Container).withConfig({
  displayName: "components__NotificationCard",
  componentId: "ds1zkc-0"
})(["background-color:", ";box-shadow:", ";border-radius:2px;width:", ";", ";"], (0, _toColorString.default)(_color.default.base.snowWhite), (0, _skyPlane.default)(2), _constants.NOTIFICATION_CARD_WIDTH, (0, _utils.applyDynamicModifiers)('borderColor', function (_ref) {
  var borderColor = _ref.borderColor;
  return (0, _styledComponents.css)(["border-left:2px solid ", ";"], borderColor);
}));
exports.NotificationCard = NotificationCard;

var IconColumn = _styledComponents.default.div.withConfig({
  displayName: "components__IconColumn",
  componentId: "ds1zkc-1"
})(["padding-left:", ";", ""], (0, _rem.default)(_spacing.default.base), function (_ref2) {
  var _ref2$right = _ref2.right,
      right = _ref2$right === void 0 ? false : _ref2$right;
  return right && (0, _styledComponents.css)(["padding-right:", ";"], (0, _rem.default)(_spacing.default.base));
});

exports.IconColumn = IconColumn;
var CloseButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "components__CloseButton",
  componentId: "ds1zkc-2"
})(["height:auto;"]);
exports.CloseButton = CloseButton;

var ActionButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "components__ActionButtonContainer",
  componentId: "ds1zkc-3"
})(["display:inline-flex;margin-right:", ";"], (0, _rem.default)(_spacing.default.base * 0.5));

exports.ActionButtonContainer = ActionButtonContainer;